<template>
  <section class="section_bg section custom_page_v2" >
    <loading-block v-if="isload==false" :loading="!isload"/>
    <card class="loading_div section_black" v-if="isload==false">
      <h2>{{ load_message }}</h2>
    </card>

    <div class="" v-if="isload==true">
      <div class="">
        <div class="section_header mobile_div back_div_element"   >
          <router-link tag="a" class="btn" :to="{name: 'setup_link'}"  ><i class="fa fa-backward"></i> Назад</router-link>

        </div>

        <div class="section_header mobile_div ">
          <div class="row  notify_tab mb-5 description">

            <div class="col-12" v-if="verifications.length>0" v-for="(verification,verification_index) in verifications" :key="'verification_'+verification.id">

              <h4    >{{ verification.title}}</h4>
              <p v-if="verification.type=='developer'">
                Роль <strong>"Исполнителя"</strong> позволяет управлять своим портфолио, а также получить доступ к новым заказам по вашей специальности.
                Помимо этого у Исполнителя свой личная персональная ссылка, где ваши клиенты смогут увидеть ваше портфолио и заказать ваши услуги у вас напрямую. А также у вас будет продвинутый доступ к проектной системе где вы сможете согласовывать счета с клиентом, вести базу знаний и не только.
              </p>
              <p v-if="verification.type=='shop'">
                Роль <strong>"Поставщика"</strong> позволяет управлять своим каталогом товаров.
                У Поставщика, есть своя персональная страница с Каталогом, через который любой пользователь сможет заказать ваш товар
              </p>


              <p v-if="verification.status==1"><span class="badge badge-success">пройдена</span></p>
              <p v-if="verification.status==2"><span class="badge badge-info">на рассмотрении</span></p>
              <p v-if="verification.status==3"><span class="badge badge-danger"> отказано</span></p>

              <p v-if="verification.status==0"><span class="badge badge-warning"> не пройдена</span></p>
              <p v-if="verification.status==0">    <router-link  v-if="verification.status==0" tag="a"    :to="{name:'setup_verification_form',params:{'id':verification.id}}" >пройти верификацию</router-link></p>
            </div>
          </div>
        </div>
      </div>
    </div>



  </section>
</template>

<script>
import Api from "@/models/Api";
import LoadingBlock from "@/components/Custom/LoadingBlock";
export default {
  name: "Verifications",
  data() {
    var app = this;

    return {
      "load_message":"Идет загрузка..",
      'isload': false,
      'verifications':[],
    }
  },
  components:{LoadingBlock},
  mounted(){
    var app=this;

    Api.loadAccount( function(data){


      app.verifications=data.verifications;

      app.isload = true;

    })


  },
}
</script>

<style scoped>

</style>